<template>
  <div class="confirm-page">
    <hint-page v-show="showHint" @close="showHint=false">
      <i>You have</i>
      <b>&nbsp;5&nbsp;minutes&nbsp;</b>
      <i>to review your outcomes, add missing notes, include more details or adjust your approach and methods to be more innovative.</i>
    </hint-page>

    <scenario-page
      v-if="activeTab === 'scenario'"
      videoId="confirmscenariovideo"
      :confirmPage="true"
    ></scenario-page>

    <roles-page v-if="activeTab === 'roles'" :confirmPage="true"></roles-page>
    
    <strategy-page v-if="activeTab === 'strategy'" :confirmPage="true"></strategy-page>

    <div v-if="activeTab === 'confirm'" class="confirm-text">
      <h1>
        
        <b>HONOURED YOUR OATH?&nbsp;</b><br>
        
        <b>BUILT ON OLD KNOWLEDGE?&nbsp;</b><br>
        
        <b>Created A NEW APPROACH?&nbsp;</b><br>
        
        <b>Ensured impact?</b>
      </h1>
    </div>

    <page-subnav>
      <page-subnav-item
        @click="activeTab = 'scenario'"
        :active="activeTab=='scenario'"
        :disabled="!$store.getters.isController"
      >scenario</page-subnav-item>
      <page-subnav-item
        @click="activeTab = 'roles'"
        :active="activeTab=='roles'"
        :disabled="!$store.getters.isController"
      >identity</page-subnav-item>
      <page-subnav-item
        @click="activeTab = 'strategy'"
        :active="activeTab=='strategy'"
        :disabled="!$store.getters.isController"
      >strategy</page-subnav-item>
    </page-subnav>
  </div>
</template>

<script>
import RolesPage from "@/pages/RolesPage.vue";
import ScenarioPage from "@/pages/ScenarioPage.vue";
import StrategyPage from "@/pages/StrategyPage.vue";
import { mapState, mapGetters } from "vuex";

import HintPage from "./HintPage.vue";
import PageSubnav from "../components/PageSubnav";
import PageSubnavItem from "../components/PageSubnavItem";

export default {
  name: "confirm-page",
  components: {
    RolesPage,
    ScenarioPage,
    StrategyPage,
    HintPage,
    PageSubnav,
    PageSubnavItem
  },
  data: function() {
    return {
      showHint: true
    };
  },
  computed: {
    ...mapState(["confirmActiveTab"]),
    ...mapGetters(["task"]),

    activeTab: {
      set(value) {
        this.$store.commit("SET_CONFIRM_TAB", value);
      },
      get() {
        console.log(this.confirmActiveTab);

        return this.confirmActiveTab;
      }
    }
  }
};
</script>

<style lang="less">
.confirm-page {
  .confirm-text {
    position: relative;
    width: 768px;
    height: 768px;
    padding: 120px;
    background-image: url("~@/assets/images/page-blank.png");
  }

  .white {
    color: #f1ece6;
  }

  .page-subnav {
      background-color: #F1ECE6;
      padding: 3px 0px 3px 5px;
  }
}
</style>
